import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'

export const contractRevisionAutoPay = async (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/auto_pay/get_contract_revision_auto_pay`)
      .then(result => {
        resolve(Util.Obj.keysToCamel(result.data.contract_revisions))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
